import * as types from './constants';

const initialState = {
  data: {},
  loading: false,
  errors_api: {}
};

const actions = {
  // Update Lookbook Order Fulfillment Package
  [types.UPDATE_LOOKBOOK_ORDER_FULFILLMENT_PACKAGE_REQUEST]: state => {
    const data = {
      ...state,
      loading: true
    };

    return { ...data };
  },

  [types.UPDATE_LOOKBOOK_ORDER_FULFILLMENT_PACKAGE_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      data: payload,
      errors_api: {}
    };

    return { ...data };
  },

  [types.UPDATE_LOOKBOOK_ORDER_FULFILLMENT_PACKAGE_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.UPDATE_LOOKBOOK_ORDER_FULFILLMENT_PACKAGE_CLEAR_ERRORS]: (state, { payload }) => {
    let errors_api = { ...state.errors_api };
    let newState = { ...state };
    if (payload) {
      delete errors_api[payload];
    } else {
      errors_api = {};
    }

    return { ...newState, errors_api };
  },

  [types.UPDATE_LOOKBOOK_ORDER_FULFILLMENT_PACKAGE_RESET]: () => {
    const data = {
      ...initialState
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};
